import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ModalConfirmationContent from '../../../../shared/components/modal-confirmation-content/modal-confirmation-content';
import Modal from '../../../../shared/components/modal/modal';
import { useConfirmationError } from '../../../../shared/hooks/use-confirmation-error';
import { useAppSelector } from '../../../../store/hooks';
import { requestPreviewAlertId } from '../../../request/constants/constants';
import LazyModal, { LazyModalComponentProps } from '../../../ui/components/lazy-modal';
import { closeModal, setAlert } from '../../../ui/store/ui-slice';
import { useDetachScanRequestMutation } from '../../api/scan-requests-api';
import { scanRequestAlertId, scanRequestDetachModalId } from '../../constants/constants';
import { selectTempScanRequestId, setTempScanRequestId } from '../../store/scan-requests-slice';

const ScanRequestDetachModalContent = ({ isOpen, afterClose }: LazyModalComponentProps): JSX.Element => {
  const { t } = useTranslation(['scan-requests', 'common']);
  const dispatch = useDispatch();
  const activeScanRequestId = useAppSelector(selectTempScanRequestId);
  const [detachScanRequest, { isLoading }] = useDetachScanRequestMutation();
  const { confirmationError, addConfirmationError, resetConfirmationError } = useConfirmationError();

  const closeFormModal = () => {
    dispatch(closeModal(scanRequestDetachModalId));
    dispatch(setTempScanRequestId(null));
  };

  const setScanRequestDetachAlertMessage = (alertId: string) => {
    dispatch(
      setAlert({
        id: alertId,
        type: 'success',
        title: t('scanRequestDetachModal.message.fileDetached'),
      }),
    );
  };

  const onModalSubmit = () => {
    if (!activeScanRequestId) {
      addConfirmationError(t('signScanRequest.validationError.detachFailed', { ns: 'common' }));
      return;
    }
    resetConfirmationError();
    detachScanRequest(activeScanRequestId)
      .unwrap()
      .then(() => {
        closeFormModal();
        setScanRequestDetachAlertMessage(scanRequestAlertId);
        setScanRequestDetachAlertMessage(requestPreviewAlertId);
      })
      .catch(() => addConfirmationError(t('signScanRequest.validationError.detachFailed', { ns: 'common' })));
  };
  return (
    <Modal
      title={t('scanRequestDetachModal.title')}
      onCancel={closeFormModal}
      isLoading={isLoading}
      customSubmitText={t('signScanRequest.action.detach', { ns: 'common' })}
      onOk={onModalSubmit}
      isOpen={isOpen}
      afterClose={afterClose}
    >
      <ModalConfirmationContent
        confirmDeleteText={t('scanRequestDetachModal.warning')}
        confirmationError={confirmationError}
      />
    </Modal>
  );
};

const ScanRequestFormDetachModal = (): JSX.Element => {
  return <LazyModal modalId={scanRequestDetachModalId} Component={ScanRequestDetachModalContent} />;
};

export default ScanRequestFormDetachModal;
